import { SortingValue } from 'shared/lib/components/controls/sorting/sortingControl';
import { ExplorerEntityTypes } from 'entities/types';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSearchParamsUtils = () => {
  const [searchParams] = useSearchParams();

  const searchSectionId = searchParams.get('searchSectionId');
  const searchFolderId = searchParams.get('searchFolderId');
  const type = searchParams.get('type') as ExplorerEntityTypes | null;
  const id = searchParams.get('id');
  const search = searchParams.get('search');
  const only_direct_match = searchParams.get('only_direct_match');
  const in_trash = searchParams.get('in_trash');
  const sort = searchParams.get('sort') as SortingValue | null;

  const getSectionSearchParams = useCallback(
    ({
      sectionId,
      in_trash = false,
    }: {
      sectionId: string;
      in_trash?: boolean;
    }) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('sort');
      newSearchParams.delete('only_direct_match');
      newSearchParams.delete('search');
      newSearchParams.delete('in_trash');
      newSearchParams.delete('searchSectionId');
      newSearchParams.delete('searchFolderId');

      newSearchParams.set('id', sectionId);
      newSearchParams.set('type', ExplorerEntityTypes.SECTION);

      if (in_trash) {
        newSearchParams.set('in_trash', 'true');
      }
      return newSearchParams.toString();
    },
    [searchParams]
  );

  const getFolderSearchParams = useCallback(
    ({ folderId, in_trash }: { folderId: string; in_trash?: boolean }) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('sort');
      newSearchParams.delete('only_direct_match');
      newSearchParams.delete('search');
      newSearchParams.delete('in_trash');
      newSearchParams.delete('searchSectionId');
      newSearchParams.delete('searchFolderId');

      newSearchParams.set('id', folderId);
      newSearchParams.set('type', ExplorerEntityTypes.FOLDER);

      if (in_trash) {
        newSearchParams.set('in_trash', 'true');
      }
      return newSearchParams.toString();
    },
    [searchParams]
  );

  const getFileSearchParams = useCallback(
    ({ fileId, in_trash }: { fileId: string; in_trash?: boolean }) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('sort');
      newSearchParams.delete('only_direct_match');
      newSearchParams.delete('search');
      newSearchParams.delete('in_trash');
      newSearchParams.delete('searchSectionId');
      newSearchParams.delete('searchFolderId');

      newSearchParams.set('id', fileId);
      newSearchParams.set('type', ExplorerEntityTypes.FILE);

      if (in_trash) {
        newSearchParams.set('in_trash', 'true');
      }

      return newSearchParams.toString();
    },
    [searchParams]
  );

  const getTableSearchParams = useCallback(
    ({ tableId, in_trash }: { tableId: string; in_trash?: boolean }) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('sort');
      newSearchParams.delete('only_direct_match');
      newSearchParams.delete('search');
      newSearchParams.delete('folderId');
      newSearchParams.delete('searchSectionId');
      newSearchParams.delete('searchFolderId');

      newSearchParams.set('id', tableId);
      newSearchParams.set('type', ExplorerEntityTypes.TABLE);

      if (in_trash) {
        newSearchParams.set('in_trash', 'true');
      }
      return newSearchParams.toString();
    },
    [searchParams]
  );

  return {
    id,
    type,
    in_trash,
    search,
    only_direct_match,
    sort,
    searchSectionId,
    searchFolderId,
    getSectionSearchParams,
    getFolderSearchParams,
    getFileSearchParams,
    getTableSearchParams,
  };
};
